import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../config/firebase';

// Fonction pour mettre à jour tous les documents utilisateurs
export const updateAllUsers = async () => {
  try {
    // Récupérer tous les documents de la collection users
    const usersSnapshot = await getDocs(collection(db, 'users'));
    
    // Pour chaque document
    const updates = usersSnapshot.docs.map(async (document) => {
      const userRef = doc(db, 'users', document.id);
      
      // Ajouter le champ mobileMoneyAccounts s'il n'existe pas
      await updateDoc(userRef, {
        mobileMoneyAccounts: []
      });
    });
    
    // Attendre que toutes les mises à jour soient terminées
    await Promise.all(updates);
    console.log('Tous les utilisateurs ont été mis à jour');
    
  } catch (error) {
    console.error('Erreur lors de la mise à jour:', error);
  }
};

const generateReferralCode = () => {
  return Math.random().toString(36).substring(2, 10);
};

export const updateExistingUsersWithReferralCodes = async () => {
  try {
    console.log('Début de la mise à jour des codes de parrainage...');
    const usersRef = collection(db, 'users');
    const snapshot = await getDocs(usersRef);
    
    for (const userDoc of snapshot.docs) {
      const userData = userDoc.data();
      
      // Vérifier si l'utilisateur n'a pas déjà un code de parrainage
      if (!userData.referralCode) {
        await updateDoc(doc(db, 'users', userDoc.id), {
          referralCode: generateReferralCode(),
          referralCount: 0,
          referralEarnings: 0
        });
        console.log(`Code de parrainage généré pour l'utilisateur ${userDoc.id}`);
      }
    }
    
    console.log('Mise à jour des codes de parrainage terminée');
  } catch (error) {
    console.error('Erreur lors de la mise à jour des codes de parrainage:', error);
  }
}; 